import { render, staticRenderFns } from "./VFairDetails.vue?vue&type=template&id=5b55e65c&scoped=true"
import script from "./VFairDetails.vue?vue&type=script&lang=ts"
export * from "./VFairDetails.vue?vue&type=script&lang=ts"
import style0 from "./VFairDetails.vue?vue&type=style&index=0&id=5b55e65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55e65c",
  null
  
)

export default component.exports